// Console environment context + hook. ConsoleLayout owns the state and provides it;
// env-scoped screens read `env` and re-fetch when it changes.
import { createContext, useContext } from "react";
import { getEnv } from "./envStore";

// Default shape so a screen rendered outside the provider still behaves (preprod).
export const EnvContext = createContext({ env: getEnv(), setEnv: () => {} });

export function useEnv() {
  return useContext(EnvContext);
}
